import { InternalRefetchQueryDescriptor } from "@apollo/client";
import { assertNever } from "@msys/common";
import { getItemPlaceholderKind, ItemPlaceholderKind } from "../helpers.js";
import { PlaceholderSelection_ItemFragment } from "./PlaceholderSelection.generated.js";
import { ProductPlaceholderSelectionPanel } from "./ProductPlaceholderSelectionPanel.js";
import { TemplatePlaceholderSelectionPanel } from "./TemplatePlaceholderSelectionPanel.js";

interface Props {
  projectId: string | null;
  docId: string;
  item: PlaceholderSelection_ItemFragment;
  /** Overrides the kind derived from the item, for an item that is both. */
  kind?: ItemPlaceholderKind;
  expandedItemIds: string[] | undefined;
  onUpdateDataRefetchQueries?: InternalRefetchQueryDescriptor[];
  refetchWizardQuestions: () => Promise<unknown>;
  handleClose: () => void;
  onApplied?: () => Promise<void>;
}

export const PlaceholderSelection = ({
  projectId,
  docId,
  item,
  kind,
  expandedItemIds,
  onUpdateDataRefetchQueries,
  refetchWizardQuestions,
  handleClose,
  onApplied,
}: Props) => {
  const placeholderKind = kind ?? getItemPlaceholderKind(item);

  if (placeholderKind === null) return null;

  switch (placeholderKind) {
    case "template":
      return (
        <TemplatePlaceholderSelectionPanel
          projectId={projectId}
          docId={docId}
          item={item}
          refetchWizardQuestions={refetchWizardQuestions}
          handleClose={handleClose}
          onApplied={onApplied}
        />
      );
    case "product":
      return (
        <ProductPlaceholderSelectionPanel
          projectId={projectId}
          docId={docId}
          item={item}
          expandedItemIds={expandedItemIds}
          onUpdateDataRefetchQueries={onUpdateDataRefetchQueries}
          refetchWizardQuestions={refetchWizardQuestions}
          handleClose={handleClose}
          onApplied={onApplied}
        />
      );
    default:
      assertNever(placeholderKind);
  }
};
